import { useEffect } from 'react'
import { useRouteError } from 'react-router'

const RELOAD_FLAG = 'chunk_error_reloaded'

/** Route-level error element. A deploy invalidates old chunk hashes, so tabs
 *  opened before the deploy fail to fetch lazy route chunks — auto-reload
 *  once to pick up the new index.html. Anything else gets a friendly screen.
 */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const message = error instanceof Error ? error.message : String(error)
  const isStaleChunk = /dynamically imported module|Importing a module script failed/i.test(message)
  const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === '1'

  useEffect(() => {
    if (isStaleChunk && !alreadyReloaded) {
      sessionStorage.setItem(RELOAD_FLAG, '1')
      window.location.reload()
    }
  }, [isStaleChunk, alreadyReloaded])

  if (isStaleChunk && !alreadyReloaded) {
    return <div className="min-h-dvh bg-slate-100" />
  }

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center bg-slate-100 gap-3 px-6 text-center">
      <p className="text-slate-700 font-semibold">Something went wrong loading this page.</p>
      <button
        onClick={() => { sessionStorage.removeItem(RELOAD_FLAG); window.location.reload() }}
        className="px-4 py-2 rounded-lg bg-beacon-600 text-white text-sm font-semibold"
      >
        Reload
      </button>
    </div>
  )
}
